module.exports = __webpack_public_path__ + "static/media/piano_pass.d45263b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/game/scene1/asset/piano_pass.jpg
// module id = 1786
// module chunks = 0